const [d] = [document]

export default function SHOP () {
  const _constructor = () => {
    const containers = d.querySelectorAll('[data-plugin="shop-item-slider"]')
    if(containers.length >= 1) Array.prototype.map.call( containers, slider_init )
  }

  const slider_init = container => {
    $(container).slick({
      dots: true,
      arrows: false,
      slidesToShow:1,
      variableWidth: false,
      adaptiveHeight: true,
      fade: true,
      speed: 190,
      customPaging: function(slider, i) {
        var thumbSrc = $(slider.$slides[i]).find('img').attr('src');
        return '<img src="' + thumbSrc + '">';
      },
      appendDots: $('[data-plugin="shop-item-slider-thumbs"]').empty()
    })
  }
  d.addEventListener('DOMContentLoaded',_constructor)
}